import React from 'react'
import { Form } from 'react-bootstrap';
import { ChevronDown } from 'react-bootstrap-icons';

const FilterDropdown = (props) => {
    const { options, value, onChange } = props;
  return (
    <div style={{ width: '100%', maxWidth: "70px", position: 'relative' }}>
        <Form.Control
          as="select"
          value={value}
          onChange={onChange}
          style={{ paddingRight: '22px' }}
        >
            {options.map((option) => (
                <option key={option.value} value={option.value}>{option.label}</option>
            ))}
        </Form.Control>
        <ChevronDown
          size={14}
          style={{
            position: 'absolute',
            right: 6,
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            opacity: 0.8
          }}
        />
    </div>
  )
}

export default FilterDropdown;